import gateByFeature from '../../util/gate_by_feature'

export default async function reports (state, appOptions, lastPage, pageOptions) {
  const Reports = (await import(/* webpackChunkName: 'reports' */ '../../apps/reports')).default

  // Feature not allowed
  if (gateByFeature('reports', state.get('user').get('features'), state)) {
    return
  }

  const reportingState = state.appStates.reporting

  const view = new Reports({
    state: reportingState
  })

  if (pageOptions.report) {
    reportingState.createReport(pageOptions.report)
  } else if (reportingState.get('report')) {
    reportingState.changeReport(reportingState.get('report'))
  } else {
    reportingState.changeReport(null)
  }

  return view
}
